<!-- src/app/pages/prescription/prescription-list/prescription-line/prescription-line.component.html -->
<div class="addContainer" data-tour="rx-line-modal">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about">
          <h4> POSOLOGIA DEL MEDICAMENTO</h4>
          MEDICAMENTO: <br />
          {{ summary }}
        </div>
      </div>
    </div>
    <button (click)="cancel()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Banner solo despues del primer intento de guardar -->
  <div
    *ngIf="attemptedSave && missingFields.length"
    class="validation-banner animate-in"
    id="poso-banner"
  >
    <mat-icon class="mr-1">warning</mat-icon>
    FALTAN CAMPOS OBLIGATORIOS:
    <ul>
      <li *ngFor="let f of missingFields">{{ f }}</li>
    </ul>
  </div>

  <div mat-dialog-content>
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>CANTIDAD:</mat-label>
          <input
            (ngModelChange)="onChangeNumber('dose', $event); revalidateIfNeeded()"
            [(ngModel)]="dose"
            aria-autocomplete="none"
            autocomplete="nope"
            matInput
            min="0"
            required
            type="number"
            data-tour="rx-line-dose"
          />
        </mat-form-field>
      </div>

      @if (data.units.length > 0) {
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>UNIDAD:</mat-label>
            <mat-select
              data-tour="rx-line-unit"
              [(value)]="unitId"
              (selectionChange)="revalidateIfNeeded()"
              (openedChange)="onSelectOpened('units')"
              panelClass="select-with-search-panel"
            >
              <!-- Buscador UNITS -->
              <mat-option *ngIf="showSearch.units" disabled class="select-search-option" style="padding-top: 5px">
                <mat-form-field class="select-search-field" appearance="outline" style="background: white">
                  <mat-label>Buscar unidad…</mat-label>
                  <input
                    #unitSearchInput
                    matInput
                    [(ngModel)]="filters.units"
                    (ngModelChange)="applyFilter('units')"
                    (keydown)="$event.stopPropagation()"
                  />
                  <button *ngIf="filters.units" matSuffix mat-icon-button (click)="clearFilter('units', unitSearchInput)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </mat-option>

              <mat-option
                *ngFor="let unit of filtered.units; trackBy: trackByUnit"
                [value]="unit.idUnit"
              >
                {{ unit.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }

      <!-- CADA (numero) -->
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2" *ngIf="frecuencyType !== idDosisUnica">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>CADA</mat-label>
          <input
            (ngModelChange)="onChangeNumber('frecuency', $event); revalidateIfNeeded()"
            [(ngModel)]="frecuency"
            aria-autocomplete="none"
            autocomplete="nope"
            class="example-right-align center-input"
            matInput
            min="1"
            type="number"
            data-tour="rx-line-each"
          />
        </mat-form-field>
      </div>

      <!-- FRECUENCIA (select) -->
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2" *ngIf="frecuencyType !== idDosisUnica">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>FRECUENCIA</mat-label>
          <mat-select
            [(ngModel)]="frecuencyType"
            required
            (selectionChange)="onFrecuencyTypeChange($event.value); revalidateIfNeeded()"
            data-tour="rx-line-freq-type"
          >
            <mat-option *ngFor="let freq of frecuencyTypes" [value]="freq.idFrecuencyType">
              {{ freq.frecuencyType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="frecuencyType === idDosisUnica">
        <mat-form-field appearance="outline" class="example-full-width">
          <input
            [disabled]="true"
            [(ngModel)]="frecuency"
            class="example-right-align center-input"
            matInput
            type="number"
            min="1"
            style="font-weight: bold; background: #f8f9fa;"
          />
          <mat-select matSuffix [(ngModel)]="frecuencyType" required disabled style="min-width:110px;">
            <mat-option [value]="idDosisUnica">
              <span style="font-weight: bold; color: #1d2671; letter-spacing: 1px;">DOSIS UNICA</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>DURACION:</mat-label>
          <input
            (ngModelChange)="onChangeNumber('duration', $event); revalidateIfNeeded()"
            [(ngModel)]="duration"
            aria-autocomplete="none"
            autocomplete="nope"
            matInput
            min="0"
            required
            type="number"
            data-tour="rx-line-duration"
          />
        </mat-form-field>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>PERIODO:</mat-label>
          <mat-select [(value)]="durationType" (selectionChange)="revalidateIfNeeded()" data-tour="rx-line-duration-type">
            <mat-option value="YEAR">AÑO(S)</mat-option>
            <mat-option value="MONTH">MES(ES)</mat-option>
            <mat-option value="WEEK">SEMANA(S)</mat-option>
            <mat-option value="DAY">DIA(S)</mat-option>
            <mat-option value="HOUR">HORA(S)</mat-option>
            <mat-option value="MINUTE">MINUTO(S)</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      @if (data.routes.length > 0) {
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>VIA:</mat-label>
            <mat-select
              [(value)]="route"
              (selectionChange)="revalidateIfNeeded()"
              (openedChange)="onSelectOpened('routes')"
              panelClass="select-with-search-panel"
              data-tour="rx-line-route"
            >
              <!-- Buscador ROUTES -->
              <mat-option *ngIf="showSearch.routes" disabled class="select-search-option" style="padding-top: 5px">
                <mat-form-field class="select-search-field" appearance="outline" style="background: white">
                  <mat-label>Buscar via…</mat-label>
                  <input
                    #routeSearchInput
                    matInput
                    [(ngModel)]="filters.routes"
                    (ngModelChange)="applyFilter('routes')"
                    (keydown)="$event.stopPropagation()"
                  />
                  <button *ngIf="filters.routes" matSuffix mat-icon-button (click)="clearFilter('routes', routeSearchInput)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </mat-option>

              <mat-option
                *ngFor="let r of filtered.routes; trackBy: trackByRoute"
                [value]="r.idRoute"
              >
                {{ r.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }

      @if (data.indications.length > 0) {
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>MOTIVO DE USO:</mat-label>
            <mat-select
              [(ngModel)]="indication"
              (selectionChange)="revalidateIfNeeded()"
              (openedChange)="onSelectOpened('indications')"
              panelClass="select-with-search-panel"
              data-tour="rx-line-indication"
            >
            <!-- Buscador INDICATIONS -->
              <mat-option *ngIf="showSearch.indications" disabled class="select-search-option" style="padding-top: 5px">
                <mat-form-field class="select-search-field" appearance="outline" style="background: white">
                  <mat-label>Buscar motivo…</mat-label>
                  <input
                    #indicationSearchInput
                    matInput
                    [(ngModel)]="filters.indications"
                    (ngModelChange)="applyFilter('indications')"
                    (keydown)="$event.stopPropagation()"
                  />
                  <button
                    *ngIf="filters.indications"
                    matSuffix
                    mat-icon-button
                    (click)="clearFilter('indications', indicationSearchInput)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </mat-option>

              <mat-option
                *ngFor="let ind of filtered.indications; trackBy: trackByIndication"
                [value]="ind.id"
              >
                {{ ind.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>INDICACIONES DE USO DEL MEDICAMENTO:</mat-label>
          <textarea
            [(ngModel)]="obs"
            appUppercaseNoAccent
            aria-autocomplete="none"
            autocomplete="nope"
            matInput
            data-tour="rx-line-obs"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
        <div class="example-button-row">
          <button
            (click)="save()"
            color="primary"
            mat-flat-button
            [disabled]="attemptedSave && missingFields.length > 0"
            data-tour="rx-line-save"
          >
            GUARDAR
          </button>
          <button (click)="cancel()" color="warn" mat-flat-button tabindex="-1">CANCELAR</button>
        </div>
      </div>
    </div>
  </div>
</div>
